import { createSelector } from 'reselect'

export const getIsArchived = (state, props) => {
  return state['view-board'].cards[props.cardContext.id].isArchived
}

export const getResponsible = (state, props) => {
  return state['view-board'].cards[props.cardContext.id].responsible
}

export const getUsers = (state, props) => {
  return state['view-board'].cards[props.cardContext.id].users
}

export default createSelector(
  [
    getIsArchived,
    getResponsible,
    getUsers
  ],
  (
    isArchived,
    responsible,
    users
  ) => ({
    isArchived,
    responsible,
    users
  })
)
